import { forwardRef } from 'react';
import { Components } from 'react-virtuoso';

export const VirtualScrollbar: Components['Scroller'] = forwardRef((props, ref) => (
  <div {...props} ref={ref} className="virtual-scrollbar" />
));
